import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import UploadSection from '../common/upload'
import i18n from '../../translations/i18n';

let SpecializedTranslation = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="form-section">
		<div className="subtitle title title-border title-border text-left">
			<h6>{i18n.t('translation.title', {lng})}</h6>
		</div>
		<div className="row">
			<div className="col-12 form-input">
				<Field
					name="specialtyField"
					component={renderSelect}
					label={i18n.t('translation.specialty_field', {lng})}
					options={props.specialtyFields}
					placeholder={i18n.t('app.please_select', {lng})}
				/>
			</div>
		</div>
		<div className="row">
			<div className="col-6 form-input">
				<Field
					name="sourceLanguage"
					component={renderSelect}
					label={i18n.t('translation.source_language', {lng})}
					placeholder={i18n.t('app.please_select', {lng})}
					options={props.fromLang}
				/>
			</div>
			<div className="col-6 form-input">
				<Field
					name="targetLanguage"
					component={renderSelect}
					label={i18n.t('translation.target_language', {lng})}
					placeholder={i18n.t('app.please_select', {lng})}
					options={props.toLang}
				/>
			</div>
		</div>
		</div>
		<div className="form-section">
			<UploadSection 
				lng={props.lng}
				service="translation"
			/>
		</div>
		{props.showHelpText&&<div>
			<p className="small-text-bold orange">{i18n.t('official.upload_help_text', {lng})}</p>
		</div>}
	</div>
	)
  }


  export default SpecializedTranslation


// WEBPACK FOOTER //
// ./src/components/translation/specialized.js